export default {
  service: {
    // api: process.env.NODE_ENV === 'production' ? 'https://api.offerago.com/api' : '/api',
    // api: process.env.NODE_ENV === 'production' ? 'https://api.offerago.com/api' : 'http://10.10.1.6:7200/api',
    api: process.env.NODE_ENV === 'production' ? 'https://api.offerago.com/api' : 'http://10.10.1.99:8002/api',
    // api: process.env.NODE_ENV === 'production' ? 'https://api.offerago.com/api' : 'https://api.offerago.com/api',
    qiniuUpload: 'https://up-z1.qiniup.com'
  },
  appid: 'wx2701a06b949a00de',
  imageUrl: process.env.NODE_ENV === 'production' ? 'https://img.offerago.com/' : '/imageUrl',
  imageUri: process.env.NODE_ENV === 'production' ? 'https://img.offerago.com/' : 'http://p35olrt47.bkt.clouddn.com/', // 图片上传与谢江博所写逻辑不兼容
  domain: process.env.NODE_ENV === 'production' ? 'https://my.offerago.com/?#' : 'http://10.10.1.202:8081/#'
}



// WEBPACK FOOTER //
// ./src/common/config/config.js